import { defineComponent as l, computed as o, createBlock as n, openBlock as d, unref as s, mergeProps as u, withCtx as b, renderSlot as f } from "vue";
import { RevButtonBase as c } from "@ds/components/ButtonBase";
import { tw as a } from "../../utils/tailwind.js";
const y = /* @__PURE__ */ l({
  name: "RevLink",
  inheritAttrs: !1,
  __name: "Link",
  props: {
    ariaDescribedby: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaLabel: { default: void 0 },
    to: { default: void 0 },
    underlined: { type: Boolean, default: !0 },
    tracking: { default: () => ({}) }
  },
  setup(r) {
    const t = r, i = o(() => [
      a`text-action-default-hi focus-visible-outline-default-hi rounded-sm font-weight-body-1-link cursor-pointer [text-align:inherit] hover:text-action-default-hi-hover`,
      t.underlined ? a`underline` : a`no-underline hover:underline`
    ]);
    return (e, p) => (d(), n(s(c), u({
      "aria-describedby": e.ariaDescribedby,
      "aria-label": e.ariaLabel,
      "aria-labelledby": e.ariaLabelledby
    }, e.$attrs, {
      class: i.value,
      to: e.to,
      tracking: e.tracking
    }), {
      default: b(() => [
        f(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-describedby", "aria-label", "aria-labelledby", "class", "to", "tracking"]));
  }
});
export {
  y as default
};
